import { PAYMENT_V2_ENDPOINT_V2 } from "@/components/Pricing/v2/constants.pricing";
import { TCloudAPIResponse } from "@/types/app";
import axios from "axios";

export type TAddress = {
  line1: string;
  line2?: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
};

export type TBillingDetail = {
  email: string;
  phone?: string;
  billing_address: TAddress;
};

interface GetUserBillingDetailOption {
  token: string;
}

type TResponse = TCloudAPIResponse<TBillingDetail>;

const APIURL = `${PAYMENT_V2_ENDPOINT_V2}/user/details`;

export async function getUserBillingDetail(
  option: GetUserBillingDetailOption,
): Promise<TResponse> {
  try {
    const response = await axios.get(APIURL, {
      headers: {
        Authorization: option.token,
      },
    });

    return response.data as TResponse;
  } catch (error: any) {
    console.error("Error fetching user billing details:", error);
    throw error;
  }
}
